import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import {
    ProviderLogo,
    useAccountCreationContext
} from "@/components/signup/account-creation";
import { Button } from "@/libraries/design/components";

export const SocialButton = () => {
    const intl = useIntl();
    const { onClickSocialButton } = useAccountCreationContext();

    return (
        <Button
            css={buttonCss}
            aria-label={intl.formatMessage(
                {
                    id: "social.label.signup",
                    defaultMessage: "sign up with {provider}"
                },
                {
                    provider: "Google"
                }
            )}
            onClick={() => onClickSocialButton("google")}
        >
            <ProviderLogo logo="google" />
            <span>Google</span>
        </Button>
    );
};

const buttonCss = css({
    height: "48px",
    boxSizing: "border-box",
    backgroundColor: token("elevation.surface"),
    // eslint-disable-next-line local/ensure-wac-token-usage
    border: "1px solid #8C8F97 !important",
    color: `${token("color.text.subtle")} !important`,
    display: "flex",
    gap: "0.5rem",
    width: "fit-content",
    minWidth: "auto",
    padding: "12px 24px !important",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["svg"]: {
        minHeight: "18px",
        minWidth: "18px"
    },
    whiteSpace: "nowrap",
    ["&:focus, &:hover"]: {
        backgroundColor: `${token("elevation.surface.hovered")} !important`
    },
    [media.below.sm]: {
        width: "100%",
        maxWidth: "100%"
    }
});
